import React from "react";
import { Row, Col } from "reactstrap";
import { maintenaceDetailstyle } from "../../../../styles/maintenanceDetailstyle";
import { themeService } from "../../../../../../theme/service/activeTheme.service";
import Rail from "./RailStatus/Rail";
import { PillTextButton } from "../../../../../../libraries/GeneralButtons";
import { languageService } from "../../../../../../Language/language.service";

export const MaintenanceExecutionsList = ({
  m1,
  selectedRowData,
  maintenanceDetails,
  onSelect,
  onFormSelect,
  onSummaryFormSelect,
  onMaterialUsageCSV,
  onMaterialUsageByExecutionCSV,
  summaryData,
  onWorkGangCSV,
}) => {
  return (
    <Col md={"12"} style={{ padding: "0px" }}>
      <div
        className="maintenance-detail-box scrollbar"
        style={{ ...themeService(maintenaceDetailstyle.MaintenanceDetailsContainer), minHeight: "470px", margin: "0 30px 0 5px" }}
      >
        <Row>
          <Col md={"12"}>
            <Rail
              m1={m1}
              selectedRowData={selectedRowData}
              data={maintenanceDetails}
              onSelect={onSelect}
              onFormSelect={onFormSelect}
              onSummaryFormSelect={onSummaryFormSelect}
              onMaterialUsageCSV={onMaterialUsageCSV}
              onMaterialUsageByExecutionCSV={onMaterialUsageByExecutionCSV}
              onWorkGangCSV={onWorkGangCSV}
              summaryData={summaryData}
            />
          </Col>
        </Row>
      </div>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/ExecutionDetail/MultiExecutionDetail.jsx/MultiExecutionDetailList.jsx